<div class="row space-between">
  <h1>What do you want to create?</h1>
  <rr-icon name="close" class="close" (click)="close()"></rr-icon>
</div>
<div class="trackwrapper row">
  <div
    class="track col space-between gap-16"
    *ngFor="let track of category.tracks"
  >
    <div class="col gap-16 w100">
      <div class="row w100 space-between">
        <rr-icon name="wind" class="roundicon"></rr-icon>
        <rr-icon name="info" color="nutral" class="info"></rr-icon>
      </div>
      <div class="col gap-8">
        <h4 class="strong">{{ track.name || track.streams[0].name }}</h4>
        <div class="description">
          {{ track.description || track.streams[0].description }}
        </div>
      </div>
    </div>
    <rr-btn
      type="Primary"
      size="Medium"
      class="w100"
      (click)="startTrack(track)"
      >Start Stream</rr-btn
    >
  </div>
</div>
<rr-spinner *ngIf="showLoading"></rr-spinner>
